import React from "react";

import { useLocale } from "../../i18n/LocaleContext";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
}

function SearchInput({ value, onChange }: SearchInputProps) {
  const { t } = useLocale();

  return (
    <input
      type="text"
      placeholder={t("search.placeholder")}
      className="w-full bg-white text-dark-3 placeholder-gray-400 border-none outline-none text-lg px-3 py-2 pr-12 md:pr-3 leading-[1.5rem]"
      autoFocus
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}

export default SearchInput;
